export const PREFORMATTED_UPDATE_CHANNEL = 'preformattedUpdateChannel'
